/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  ISalesCostumeInventoryMethods,
  SalesCostumeInventoryService,
  IPresentationListsMethods,
  PresentationListsService,
  PaymentStatsReportPageService,
  IPaymentStatsReportMethods,
} from "./components";

export type SalesReportPageAgent = IHeaderMethods &
  IStaticPageContentMethods &
  ISalesCostumeInventoryMethods &
  IPaymentStatsReportMethods &
  IPresentationListsMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new PresentationListsService(),
    new PaymentStatsReportPageService(),
    new SalesCostumeInventoryService(),
  ];
};

export const getAgent = () => {
  return createAgent<SalesReportPageAgent>({
    plugins: getPlugins(),
  });
};
